import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsAccordionBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsAccordionBlockEntity
